// extracted by mini-css-extract-plugin
module.exports = {"options_area":"styles_options_area__5ooLb","option":"styles_option__2Xxh1"};